import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import * as React from "react";

interface InputProps {
  data?: {
    message: string;
    isAvailable: boolean;
    referenceModelName?: string;
    referenceId?: number;
  };
  open: boolean;
  onClose: () => void;
  onForceAssign: () => void;
}

export const AssignCookErrorDialog = (props: InputProps) => {
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogContent>
        <p>{props.data?.message}</p>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="warning"
          onClick={() => {
            props.onClose();
            props.onForceAssign();
          }}
        >
          Assign Anyway
        </Button>
        <Button variant="contained" color="error" onClick={props.onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
